/** Client-side validation + display helpers for the Upload a Package flow. */

export const MAX_BINARY_UPLOAD_BYTES = 200 * 1024 * 1024; // matches device-service BINARY_UPLOAD_MAX_BYTES default

export const ALLOWED_BINARY_EXTENSIONS = ['.apk', '.aab', '.ipa'];

export const isAllowedBinaryFile = (fileName: string): boolean => {
  const lower = fileName.toLowerCase();
  return ALLOWED_BINARY_EXTENSIONS.some(extension => lower.endsWith(extension));
};

/**
 * First check — runs when a file is selected. Returns the inline warning message
 * to display, or an empty string when the file passes.
 */
export const validateBinaryFile = (file: File): string => {
  if (!isAllowedBinaryFile(file.name)) {
    return `${file.name} isn't a valid app file. Please upload an .apk, .aab, or .ipa file.`;
  }
  if (file.size > MAX_BINARY_UPLOAD_BYTES) {
    return 'Upload a file less than 200 MB in size';
  }
  return '';
};

/** Formats a byte count for display next to the selected file (e.g. "47.2 MB"). */
export const displayFileSize = (size: number): string => {
  const oneKilobyte = 1024;
  const oneMegabyte = 1024 * 1024;
  if (size < oneKilobyte) return `${size} bytes`;
  if (size < oneMegabyte) return `${(size / oneKilobyte).toFixed(1)} KB`;
  return `${(size / oneMegabyte).toFixed(1)} MB`;
};
